import { useEffect } from 'react';

export function useFocusOut({
  ref,
  onFocusOut,
  handleClick = true,
  handleKeyup = false,
  enableModal = false,
}: {
  ref?: HTMLElement | null;
  onFocusOut: (isFocusOut: boolean) => void;
  handleClick?: boolean;
  handleKeyup?: boolean;
  enableModal?: boolean;
}) {
  useEffect(() => {
    const handleFocusOutEvent = (ref: HTMLElement, event: MouseEvent | KeyboardEvent) => {
      if (ref.contains(event.target as Node) || enableModal) {
        onFocusOut(false);
      } else {
        onFocusOut(true);
      }
    };

    const clickListener = (event: MouseEvent) => {
      if (ref && handleClick) {
        handleFocusOutEvent(ref, event);
      }
    };

    const keyupListener = (event: KeyboardEvent) => {
      if (handleKeyup && event.key === 'Escape' && enableModal) {
        onFocusOut(true);
      }

      if (ref && handleKeyup && event.key === 'Tab') {
        handleFocusOutEvent(ref, event);
      }
    };

    document.addEventListener('click', clickListener);
    document.addEventListener('keyup', keyupListener);

    return () => {
      document.removeEventListener('click', clickListener);
      document.removeEventListener('keyup', keyupListener);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ref]);
}
